export const PortalViewId = {
  Home: 'home',
  PropertiesList: 'properties.list',
  PropertiesDetails: 'properties.details',
  PropertiesSettings: 'properties.settings',
  PropertiesOpeningHours: 'properties.opening-hours',
  PropertiesSalesChannels: 'properties.sales-channels',
  SettingsThirdPartyDelivery: 'settings.third-party-delivery',
} as const;

export type PortalViewId = (typeof PortalViewId)[keyof typeof PortalViewId];
